export interface ProccessBulkEdit {
  id: number;
  filter: any;
  ids: string[];
}

export interface BulkEditFilter {
  searchValue?: string | null;
  departement?: string | null;
  area?: string | null;
  workTime?: string | null;
  site?: string | null;
  society?: string | null;
  service?: string | null;
  type?: string | null;
  fonction?: string | null;
  min?: string | null;
  max?: string | null;
  offreId?: number | null;
  dateMin?: string | null;
  dateMax?: string | null;
  date_created_max?: string | null;
  date_created_min?: string | null;
  range_min?: string | null;
  range_max?: string | null;
  range_min_profil?: string | null;
  range_max_profil?: string | null;
  status?: number[] | null;
  contrat?: string | null;
  typeConge?: string | null;
  typeHardware?: string | null;
  typeSoftware?: string | null;
  dateFormat?: string | null;
  lisenceType?: string | null;
  typeIntervention?: string | null;
  priority?: string | null;
  natureIntervention?: string | null;
  ids?: string[] | null[];
  idsNotSelected?: string[] | null[];
  dateFinDabonnementMin?: string | null;
  dateFinDabonnementMax?: string | null;
  country?: string | null;
  language?: string | null;
  statutArchive?: string | null;
  dataSourceId?: string | null;
  collaborateur?: string | null;
  year?: string | null;
  filterType?: string | null;
  maxClosureDate?: string | null;
  minClosureDate?: string | null;
  tag?: string | null;
  events?: string | null;
  monthDate?: string | null;
}

export interface DataListingFilters {
  departement?: string | null;
  fonction?: string | null;
  site?: string | null;
  contrat?: string | null;
  society?: string | null;
  status?: string | null;
  dataSourceId?: string | null;
}

export interface DataListingFilter {
  start: number;
  length: number;
  search: { value: string | null; regex: boolean };
  order: { column: string; dir: string; custom: boolean }[];
  filters: DataListingFilters;
}

export interface EditBulkData {
  id: number;
  userName: string | null;
  firstName: string | null;
  lastName: string | null;
  connectWithPhoneNumber: boolean | null;
  connectWithPhoneNumberText: string | null;
  gender: string | null;
  phoneNumber: string | null;
  birthDate: string | null;
  nationality: string | null;
  nationalityName: string | null;
  emailperso: string | null;
  phoneNumberperso: string | null;
  adresse: string | null;
  ville: string | null;
  region: string | null;
  codePostal: string | null;
  country: string | null;
  countryName: string | null;
  matricule: string | null;
  hiringDate: string | null;
  typeOfContrat: string | null;
  typeOfContratName: string | null;
  cnss: string | null;
  endOfTrial: string | null;
  endDate: string | null;
  status: string | null;
  statusName: string | null;
  familyStatus: string | null;
  errorMessage: string | null;
  cin: string | null;
  soldInitial: string | null;
  salaire: number | null;
  salaryCurrency: string | null;
  userId: string | null;
  importationId: number | null;
  isUpdated: boolean | null;
  fonctionId: number | null;
  departementId: number | null;
  teamId: number | null;
  siteId: number | null;
  societyId: number | null;
  workTimeId: number | null;
  fk_RigimeCongee: number | null;
  fonctionName: string | null;
  departementName: string | null;
  teamName: string | null;
  siteName: string | null;
  societyName: string | null;
  workTimeName: string | null;
  timeoff_policies: string | null;
  supervisor: string | null;
  lang: string | null;
  langName: string | null;
  soldeReg: number | null;
  changedFields?: string[] | null;
  previousValues?: string[] | null;
}

export enum BulkEditStatuses {
  Pending = 1,
  Initial = 2,
  InProgress = 3,
  Terminated = 4,
  Failed = 5,
}

export interface HistoryBulkEdit {
  id: number;
  status: BulkEditStatuses;
  totalUsersCreated: number;
  totalUsersUpdated: number;
  filePath: string | null;
  completeDate: string | null;
  createdDate: string;
  createdBy: {
    value: string | null;
    text: string;
    smallText: string | null;
    imagePath: string | null;
    labelGroup: string | null;
    valueGroup: string | null;
    selected: boolean;
    type: string | null;
    date: string | null;
    order: string | null;
  };
  updatedBy: {
    value: string | null;
    text: string;
    smallText: string | null;
    imagePath: string | null;
    labelGroup: string | null;
    valueGroup: string | null;
    selected: boolean;
    type: string | null;
    date: string | null;
    order: string | null;
  };
}

export interface AffectUsersBulkEdit {
  id: number;
  ids: string | string[];
  fieldName: string;
  fieldValue: string;
  fields: SelectItem[];
  /**
   * Active list filters, only sent when `ids` is `'all'` so the backend can
   * resolve "all" against the same subset the user was looking at.
   */
  filters?: DataListingFilters;
}

export interface BulkEditStatistics {
  id: number;
  closed: boolean;
  numberOfUsers: number;
  numberOfUsersToChange: number;
  numberOfUsersToCreate: number;
  numberOfUsersUnmatched: number;
  status: string | null;
  state: number;
  contracts: SelectItem[];
  genres: SelectItem[];
  nationalitys: SelectItem[];
  fonctions: SelectItem[];
  departements: SelectItem[];
  teams: SelectItem[];
  sites: SelectItem[];
  societys: SelectItem[];
  regimes: SelectItem[];
  familyStatus: SelectItem[];
  timeoff_policies: SelectItem[];
  supervisor: SelectItem[] | null;
  languages: SelectItem[];
  currencies: SelectItem[] | null;
}

export interface BulkEditDataListing {
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
  visible: boolean;
  data: EditBulkData[];
}
